var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 82",
    style: {
      enableBackground: "new 0 0 380 82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3CB4E5;}\r\n\t.st1{fill:#00953B;}\r\n\t.st2{fill:#1E1E1C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_445_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_481_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_662_",
    className: "st0",
    cx: 211.56,
    cy: 40.89,
    r: 10.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_661_",
    className: "st0",
    cx: 184.73,
    cy: 40.89,
    r: 8.77
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_660_",
    className: "st0",
    cx: 160.7,
    cy: 40.89,
    r: 7.31
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_659_",
    className: "st0",
    cx: 140.5,
    cy: 40.89,
    r: 5.85
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_658_",
    className: "st0",
    cx: 123.35,
    cy: 40.89,
    r: 4.38
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_405_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_657_",
    className: "st0",
    cx: 211.56,
    cy: 67.72,
    r: 10.23
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_404_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_431_",
    className: "st0",
    cx: 184.73,
    cy: 66.26,
    r: 8.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_430_",
    className: "st0",
    cx: 160.7,
    cy: 64.79,
    r: 7.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_402_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_429_",
    className: "st0",
    cx: 140.5,
    cy: 63.33,
    r: 5.85
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_401_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_428_",
    className: "st0",
    cx: 123.35,
    cy: 61.87,
    r: 4.38
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_427_",
    className: "st0",
    cx: 211.56,
    cy: 14.28,
    r: 10.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_426_",
    className: "st0",
    cx: 184.73,
    cy: 15.74,
    r: 8.77
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_425_",
    className: "st0",
    cx: 160.7,
    cy: 17.21,
    r: 7.31
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_424_",
    className: "st0",
    cx: 140.5,
    cy: 18.67,
    r: 5.85
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_423_",
    className: "st0",
    cx: 123.35,
    cy: 20.13,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_422_",
    className: "st1",
    cx: 13.53,
    cy: 41.1,
    r: 10.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_421_",
    className: "st1",
    cx: 40.36,
    cy: 40.97,
    r: 8.77
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_420_",
    className: "st1",
    cx: 64.39,
    cy: 40.85,
    r: 7.31
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_418_",
    className: "st1",
    cx: 84.59,
    cy: 40.74,
    r: 5.85
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_417_",
    className: "st1",
    cx: 101.74,
    cy: 40.65,
    r: 4.38
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_400_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_415_",
    className: "st1",
    cx: 13.67,
    cy: 67.72,
    r: 10.23
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_364_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_414_",
    className: "st1",
    cx: 40.5,
    cy: 66.26,
    r: 8.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_218_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_413_",
    className: "st1",
    cx: 64.53,
    cy: 64.79,
    r: 7.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_243_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_412_",
    className: "st1",
    cx: 84.73,
    cy: 63.33,
    r: 5.85
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_242_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_411_",
    className: "st1",
    cx: 101.88,
    cy: 61.87,
    r: 4.38
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_410_",
    className: "st1",
    cx: 13.39,
    cy: 14.28,
    r: 10.23
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_409_",
    className: "st1",
    cx: 40.22,
    cy: 15.74,
    r: 8.77
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_408_",
    className: "st1",
    cx: 64.25,
    cy: 17.21,
    r: 7.31
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_407_",
    className: "st1",
    cx: 84.46,
    cy: 18.67,
    r: 5.85
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_406_",
    className: "st1",
    cx: 101.6,
    cy: 20.13,
    r: 4.38
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_433_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.08,13.74l-0.97,1.64v5.57h-1.85V4.35h1.85v8.01l4.41-8.01h1.87l-4.2,7.56l4.34,9.03h-1.9L241.08,13.74z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.75,11.7v1.66h-4.05v5.9h4.98v1.68h-6.83V4.35h6.83v1.68h-4.98v5.66H255.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.4,20.92h-1.78l-2.75-13.2v13.23h-1.61V4.35h2.58l2.73,13.25l2.63-13.25h2.58v16.59h-1.75V7.6 L266.4,20.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.44,17.6l-0.64,3.34h-1.71l3.18-16.59h2.68l3.18,16.59h-1.85l-0.64-3.34H276.44z M276.68,16.01h3.7 l-1.87-9.58L276.68,16.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.96,20.94V6.03h-3.06V4.35h7.94v1.68h-3.06v14.91H287.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.9,11.7v1.66h-4.05v5.9h4.98v1.68H296V4.35h6.83v1.68h-4.98v5.66H301.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313.75,8.36v1.49h-1.75V8.26c0-1.49-0.59-2.39-1.94-2.39c-1.33,0-1.94,0.9-1.94,2.39v8.77 c0,1.49,0.62,2.39,1.94,2.39c1.35,0,1.94-0.9,1.94-2.39v-2.16h1.75v2.06c0,2.51-1.19,4.17-3.74,4.17c-2.54,0-3.72-1.66-3.72-4.17 V8.36c0-2.51,1.19-4.17,3.72-4.17C312.56,4.19,313.75,5.84,313.75,8.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.18,13.48v7.47h-1.85V4.35h1.85v7.47h4.08V4.35h1.85v16.59h-1.85v-7.47H319.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M330.53,20.94h-1.66V4.35h2.35l3.84,11.99V4.35h1.64v16.59h-1.92l-4.24-13.41V20.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.33,4.35v16.59h-1.85V4.35H342.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M348.94,13.74l-0.97,1.64v5.57h-1.85V4.35h1.85v8.01l4.41-8.01h1.87l-4.2,7.56l4.34,9.03h-1.9L348.94,13.74z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.11,32.79v16.59h-1.85V32.79H240.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M245.54,49.38h-1.66V32.79h2.35l3.84,11.99V32.79h1.64v16.59h-1.92l-4.24-13.41V49.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.13,49.38h-1.66V32.79h2.35l3.84,11.99V32.79h1.64v16.59h-1.92l-4.24-13.41V49.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.94,36.8c0-2.54,1.26-4.17,3.79-4.17c2.56,0,3.82,1.64,3.82,4.17v8.58c0,2.51-1.26,4.17-3.82,4.17 c-2.54,0-3.79-1.66-3.79-4.17V36.8z M268.77,45.47c0,1.52,0.64,2.39,1.97,2.39c1.35,0,1.97-0.88,1.97-2.39V36.7 c0-1.49-0.62-2.39-1.97-2.39c-1.33,0-1.97,0.9-1.97,2.39V45.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.31,49.36h-1.78l-2.75-13.2v13.23h-1.61V32.79h2.58l2.73,13.25l2.63-13.25h2.58v16.59h-1.75V36.04 L284.31,49.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.35,36.8c0-2.54,1.26-4.17,3.79-4.17c2.56,0,3.82,1.64,3.82,4.17v8.58c0,2.51-1.26,4.17-3.82,4.17 c-2.54,0-3.79-1.66-3.79-4.17V36.8z M294.17,45.47c0,1.52,0.64,2.39,1.97,2.39c1.35,0,1.97-0.88,1.97-2.39V36.7 c0-1.49-0.62-2.39-1.97-2.39c-1.33,0-1.97,0.9-1.97,2.39V45.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.24,49.38h-1.66V32.79h2.35l3.84,11.99V32.79h1.64v16.59h-1.92l-4.24-13.41V49.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.59,49.38V34.48h-3.06v-1.68h7.94v1.68h-3.06v14.91H317.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.59,46.04l-0.64,3.34h-1.71l3.18-16.59h2.68l3.18,16.59h-1.85l-0.64-3.34H326.59z M326.83,44.45h3.7 l-1.87-9.58L326.83,44.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.92,36.8v1.42h-1.75V36.7c0-1.49-0.59-2.39-1.94-2.39c-1.33,0-1.94,0.9-1.94,2.39v8.77 c0,1.49,0.62,2.39,1.94,2.39c1.35,0,1.94-0.9,1.94-2.39v-3.32h-1.71V40.5h3.46v4.88c0,2.51-1.19,4.17-3.74,4.17 c-2.54,0-3.72-1.66-3.72-4.17V36.8c0-2.51,1.19-4.17,3.72-4.17C342.73,32.63,343.92,34.29,343.92,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M353.47,40.14v1.66h-4.05v5.9h4.98v1.68h-6.83V32.79h6.83v1.68h-4.98v5.66H353.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.73,68.37V70h-3.7v6.96h-1.79V60.88h6.39v1.63h-4.6v5.86H243.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.61,68v1.61h-3.93v5.72h4.83v1.63h-6.62V60.88h6.62v1.63h-4.83V68H253.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258,76.97V60.88h1.79v14.46h4.6v1.63H258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.71,73.08c0,2.44-1.13,4.07-3.61,4.07c-2.46,0-3.59-1.63-3.59-4.07V60.88h1.77v12.3 c0,1.45,0.57,2.32,1.88,2.32c1.29,0,1.86-0.87,1.86-2.32v-12.3h1.68V73.08z M270.51,57.89v2.07h-1.59v-2.07H270.51z  M273.36,57.89v2.07h-1.56v-2.07H273.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.32,76.97V60.88h1.79v14.46h4.6v1.63H278.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.63,68v1.61h-3.93v5.72h4.83v1.63h-6.62V60.88h6.62v1.63h-4.83V68H293.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.34,76.97V62.51h-2.97v-1.63h7.7v1.63h-2.97v14.46H300.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M310.87,69.98l-0.94,1.59v5.4h-1.79V60.88h1.79v7.77l4.28-7.77h1.82l-4.07,7.33l4.21,8.76h-1.84 L310.87,69.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M325.1,68v1.61h-3.93v5.72h4.83v1.63h-6.62V60.88h6.62v1.63h-4.83V68H325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.54,76.97h-7.31v-1.61l5.52-12.85h-5.26v-1.63h7.1v1.61l-5.54,12.85h5.49V76.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M345.76,68v1.61h-3.93v5.72h4.83v1.63h-6.62V60.88h6.62v1.63h-4.83V68H345.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350.15,76.97V60.88h1.79v14.46h4.6v1.63H350.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.46,68v1.61h-3.93v5.72h4.83v1.63h-6.62V60.88h6.62v1.63h-4.83V68H365.46z M365.32,57.61l-2.14,2.37 h-1.24l1.61-2.37H365.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.81,64.74v0.44h-1.7v-0.53c0-1.45-0.55-2.3-1.84-2.3c-1.29,0-1.84,0.85-1.84,2.28 c0,3.61,5.4,3.95,5.4,8.48c0,2.44-1.17,4.02-3.63,4.02s-3.61-1.59-3.61-4.02v-0.92h1.68v1.01c0,1.45,0.6,2.3,1.88,2.3 c1.29,0,1.88-0.85,1.88-2.3c0-3.59-5.38-3.93-5.38-8.46c0-2.48,1.15-4.02,3.56-4.02C375.66,60.72,376.81,62.3,376.81,64.74z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3204db7fbebc20cc4822defa45b6a291.svg";
export { ForwardRef as ReactComponent };